import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.productInventory',
    modules: [
        R,
    ],
})
@Service('ProductInventoryStore')
export default class Store extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('product_inventory');
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/productInventory.js